// extracted by mini-css-extract-plugin
export default {"cls1":"RecommendedPodcastBadge-cls1__c031d1a879dc8f7bd3de","cls2":"RecommendedPodcastBadge-cls2__f325173cc6fccbd52259 RecommendedPodcastBadge-cls1__c031d1a879dc8f7bd3de"};